import cookie from 'js-cookie';
import { v4 as uuid } from 'uuid';

const key = 'sid';
const attempt = <R>(cb: () => R): R | null => {
  try {
    return cb();
  } catch (e) {
    return null;
  }
};

export class SessionIdManager {
  private sessionId: string;

  create() {
    this.sessionId = uuid();
    this.push();
  }

  getSessionId() {
    if (!this.sessionId) {
      this.pull();
    }

    return this.sessionId;
  }

  pull() {
    const localStorageValue = attempt(() => localStorage.getItem(key));
    const cookieValue = attempt(() => cookie.get(key));

    const sid = localStorageValue || cookieValue;

    if (sid) {
      this.sessionId = sid;
    } else {
      this.create();
    }
  }

  push() {
    try {
      cookie.set(key, this.sessionId);
    } catch (e) {
      console.warn(e);
    }

    try {
      localStorage.setItem(key, this.sessionId);
    } catch (e) {
      console.warn(e);
    }
  }
}
